<div class="breadcrumb-header justify-content-between informes-header">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto informes-title">Informes RX</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Subir Resultados / Pendientes</span>
    </div>
  </div>
  <div class="d-flex my-xl-auto right-content align-items-center gap-2 d-none d-md-flex">
    <button class="btn btn-outline-secondary" (click)="cargarPendientes()" [disabled]="cargando">
      <i class="material-icons" style="font-size:18px;vertical-align:middle">refresh</i> Recargar
    </button>
  </div>
</div>

<div class="mobile-inline-actions d-md-none mb-2">
  <button class="btn btn-outline-secondary w-100" (click)="cargarPendientes()" [disabled]="cargando">
    <i class="material-icons" style="font-size:18px;vertical-align:middle">refresh</i> Recargar
  </button>
</div>

<div class="row row-sm">
  <div class="col-md-12">

    @if (cargando) {
      <div class="text-center py-4">
        <div class="spinner-grow text-primary" role="status"></div>
        <p class="mt-2 text-muted">Cargando informes pendientes...</p>
      </div>
    }

    @if (!cargando) {
      <div class="card informes-card">
        <h6 class="card-title text-uppercase p-2 text-white mb-1" style="background-color:#2E3D8C">
          Pendientes de informe RX
        </h6>
        <div class="card-body informes-card-body">
          <div class="table-responsive d-none d-md-block">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
              class="table table-bordered table-striped table-hover dt-ext">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nº Orden</th>
                  <th>Paciente</th>
                  <th>Doctor</th>
                  <th>Servicio</th>
                  <th>Código</th>
                  <th>Fecha</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                @for (item of informes; track item; let i = $index) {
                  <tr>
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.NUM_ORD }}</td>
                    <td>{{ item.NOM_CLI }}</td>
                    <td>{{ item.NOM_DOC }}</td>
                    <td>{{ item.NOM_PRO }}</td>
                    <td>{{ item.CODN_PRO }}</td>
                    <td>{{ item.created_at | date:'dd/MM/yyyy HH:mm' }}</td>
                    <td>
                      <button class="btn btn-primary btn-sm" (click)="abrirInforme(item)">
                        <i class="material-icons" style="font-size:16px;vertical-align:middle">edit_note</i>
                        Generar informe
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="d-md-none mobile-informes-list">
            @for (item of informes; track item; let i = $index) {
              <div class="mobile-informe-card">
                <div class="mobile-informe-card__header">
                  <span class="mobile-informe-index">Pendiente {{ i + 1 }}</span>
                  <span class="mobile-informe-order">Orden {{ item.NUM_ORD }}</span>
                </div>
                <div class="mobile-informe-card__body">
                  <p class="mobile-informe-label">Paciente</p>
                  <p class="mobile-informe-value">{{ item.NOM_CLI }}</p>
                  <p class="mobile-informe-label">Doctor</p>
                  <p class="mobile-informe-value">{{ item.NOM_DOC }}</p>
                  <p class="mobile-informe-label">Servicio</p>
                  <p class="mobile-informe-value">{{ item.NOM_PRO }}</p>
                  <div class="mobile-informe-grid">
                    <div>
                      <p class="mobile-informe-label">Código</p>
                      <p class="mobile-informe-value">{{ item.CODN_PRO }}</p>
                    </div>
                    <div>
                      <p class="mobile-informe-label">Fecha</p>
                      <p class="mobile-informe-value">{{ item.created_at | date:'dd/MM/yyyy HH:mm' }}</p>
                    </div>
                  </div>
                  <button class="btn btn-primary btn-sm mobile-informe-action" (click)="abrirInforme(item)">
                    <i class="material-icons" style="font-size:16px;vertical-align:middle">edit_note</i>
                    Generar informe
                  </button>
                </div>
              </div>
            }
            @if (informes.length === 0) {
              <div class="text-center py-3 text-muted">
                No hay informes pendientes.
              </div>
            }
          </div>
        </div>
      </div>
    }

  </div>
</div>
